var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v("Contract Type")]),
    _vm._v(" "),
    _c("div", { staticClass: "panel panel-grey" }, [
      _c("div", { staticClass: "panel-body" }, [
        _c(
          "div",
          [
            _c("selectize", {
              staticClass: "selectize selectize-single",
              attrs: { name: "contract", options: _vm.contractOptions },
              model: {
                value: _vm.stateFirstContractId,
                callback: function ($$v) {
                  _vm.stateFirstContractId = $$v
                },
                expression: "stateFirstContractId",
              },
            }),
            _vm._v(" "),
            _vm.activeContract && !_vm.contractChanged
              ? _c("div", { staticClass: "spacer-y-2" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6 col-sm-12 col-xs-12" }, [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(_vm._s(_vm.activeContract.name)),
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.activeContract.description))]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                      [
                        _c("p", [
                          _vm._v("Start:\n                "),
                          _vm.activeContract.pivot !== null &&
                          _vm.activeContract.pivot.start_date !== null
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.activeContract.pivot.start_date,
                                    expression:
                                      "activeContract.pivot.start_date",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  name: "start_date",
                                  type: "date",
                                  placeholder: "2025-01-01",
                                },
                                domProps: {
                                  value: _vm.activeContract.pivot.start_date,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.activeContract.pivot,
                                      "start_date",
                                      $event.target.value
                                    )
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.activeContract.start_date,
                                    expression: "activeContract.start_date",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  name: "start_date",
                                  type: "date",
                                  placeholder: "2025-01-01",
                                },
                                domProps: {
                                  value: _vm.activeContract.start_date,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.activeContract,
                                      "start_date",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                      [
                        _c("p", [
                          _vm._v("End:\n                "),
                          _vm.activeContract.pivot !== null &&
                          _vm.activeContract.pivot.end_date !== null
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.activeContract.pivot.end_date,
                                    expression: "activeContract.pivot.end_date",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  name: "end_date",
                                  type: "date",
                                  placeholder: "2025-01-01",
                                },
                                domProps: {
                                  value: _vm.activeContract.pivot.end_date,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.activeContract.pivot,
                                      "end_date",
                                      $event.target.value
                                    )
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.activeContract.end_date,
                                    expression: "activeContract.end_date",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  name: "end_date",
                                  type: "date",
                                  placeholder: "2025-01-01",
                                },
                                domProps: {
                                  value: _vm.activeContract.end_date,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.activeContract,
                                      "end_date",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-12 col-xs-12" }, [
                      _vm.user.contracts &&
                      _vm.user.contracts.length &&
                      _vm.user.contracts[0].user_requirement_values.length
                        ? _c(
                            "div",
                            [
                              _c("h3", [_vm._v("Requirements")]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.user.contracts[0].user_requirement_values,
                                function (requirement) {
                                  return _c("span", { key: requirement.id }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(requirement.name) +
                                        ": " +
                                        _vm._s(requirement.value) +
                                        _vm._s(
                                          requirement.requirement_value
                                            ? "/" +
                                                requirement.requirement_value
                                            : ""
                                        )
                                    ),
                                    _c("br"),
                                  ])
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ])
              : _vm.contractChanged
              ? _c("div", { staticClass: "spacer-y-2" }, [
                  _c("p", [
                    _vm._v(
                      "\n            The contract has changed. Please 'save' to update the information.\n          "
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-footer" },
        [
          _c(
            "ladda-button",
            {
              staticClass: "btn btn-sm btn-primary",
              attrs: {
                type: "submit",
                click: _vm.handleSaveContract,
                disabled: _vm.userIsAdmin && !_vm.canEditAdmin,
              },
            },
            [_vm._v("\n        Save\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }